<template>
  <v-dialog
    :width="width"
    v-model="value"
    :persistent="persistent"
    @close="$emit('close')"
  >
    <v-card class="mb-0">
      <v-card-text>
        <v-layout row wrap>
          <v-btn icon large absolute right class="m-0" @click="$emit('close')">
            <i class="bexsicon-close" />
          </v-btn>
          <v-flex xs12 :class="`modal__title ${titleClass}`">
            {{ title }}
          </v-flex>
          <v-flex xs12 class="modal__text">
            <span v-html="content" />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pr-4 pl-4">
        <slot name="customActions">
          <v-checkbox
            v-if="dontShowAgain"
            v-model="checkbox"
            label="Não mostrar novamente"
            @click.native="$emit('dontShowAgain', checkbox)"
          ></v-checkbox>
          <v-btn
            @click="$emit('input', false)"
            class="success--background white--text"
          >
            {{ confirmLabel || $t('actions.confirm') }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'modal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    persistent: {
      type: Boolean,
      required: true,
    },
    confirmLabel: {
      type: String,
    },
    width: {
      type: String,
      default: '800',
    },
    title: {
      type: String,
      required: true,
    },
    titleClass: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      required: true,
    },
    dontShowAgain: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkbox: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.modal {
  &__title {
    text-align: center;
    font-size: 1.5em;
    color: var(--light-dark-color);
    line-height: 32px;
    margin: 10px 0;
  }

  &__text {
    text-align: justify;
    background-color: #f1f0f0;
    border-radius: 5px;
    padding: 25px 20px;
    color: var(--light-dark-color);
    margin: 10px 0;
    max-height: 450px;
    overflow-y: auto;
    white-space: pre-line;
  }

  >>> .v-input--selection-controls__input input {
    bottom: 2px !important;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/layout/Modal.vue